import type { PlainEnvironment } from "@/queries/environment-queries";
import { useMemo } from "react";
import type { PlainAgentExecution } from "@/queries/agent-queries";
import { getEnvironmentDisplayName } from "@/utils/environment";

export function useEnvironmentName(environment?: PlainEnvironment, agentExecution?: PlainAgentExecution) {
    const name = useMemo(() => {
        if (!environment) {
            // For undefined environments, return the same default as getBranchFromInitializer
            return "main";
        }
        return getEnvironmentDisplayName(environment, agentExecution);
    }, [environment, agentExecution]);
    return name;
}
